<template>
	<v-card class="shadowCard" >
	  <v-img
	    src="@/assets/backgrounds/back_comparte_gana.jpg"
	    height="200px"
	    class="white--text align-center justify-center text-center"
	  >
	    <div class="text-h4">¡COMPARTE Y GANA!</div><br/>
	    <v-avatar
	      size="60"
	      color="transparent"
	      rounded
	      class="elevation-0"
	    >
	      <ul class="feedback" style="text-align: center; align-content: center; align-items: center; justify-content: center; justify-items: center;">
	        <li class="happy active">
	          <div>
	            <svg class="eye left">
	              <use xlink:href="#eye"></use>
	            </svg>
	            <svg class="eye right">
	              <use xlink:href="#eye"></use>
	            </svg>
	          </div>
	        </li>
	      </ul>
	      <br/>
	    </v-avatar>
	    <br/>
      <v-btn color="blue" dark rounded class="elevation-12" :to="{ name: 'Recomendados' }">Ver más</v-btn>

	    <!-- <a class="more-link" @click="alertaComparte.estatus = true">Ver más</a> -->
	  </v-img>
	  <!-- <ComparteGana   v-if="alertaComparte.estatus"  :alertaComparte="alertaComparte" @click="salirLogin()"/> -->
	</v-card>
</template>
<script>
	// Importar lebrerías
	import { mapGetters, mapActions } from 'vuex'
  const  base64 = require('base-64');
  import { Clipboard } from '@capacitor/clipboard';
  // import { Share } from '@capacitor/share';
  import ComparteGana  from '@/components/alertas/ComparteGana.vue'
  import { Capacitor } from '@capacitor/core';

  export default {
  	components:{
      ComparteGana
  	},

    data () {
      return {
        alertaComparte:{
          estatus: false,
        },
      }
    },
    
    computed:{
      ...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS', 'getRecursosGrupoUsuario', 'getGrupos', 'getEscuela' ]),
    },

    methods:{
      async copiarPortapapeles( ){
        const matricula = this.getUsuarioLMS.usuario
        let   mensaje   = ''

        if( this.getEscuela == 2 ){
          mensaje = 'https://wa.me/+5218120494796?text=Hola,+me+interesa+aprovechar+el+descuento+especial+para+estudiar+inglés.+Me+recomendó+el+alumno+con+matricula+'+matricula
        }else{
          mensaje = 'https://wa.me/+5218120474412?text=Hola,+me+interesa+aprovechar+el+descuento+especial+para+estudiar+inglés.+Me+recomendó+el+alumno+con+matricula+'+matricula
        }

        Clipboard.write({
          string: mensaje
        });

        if (Capacitor.isNative) {
          // Si es una app nativa, llamamos al código nativo para compartir
          const { shareContent } = Capacitor.Plugins;
          await shareContent({
            title: 'Comparte y gana',
            text: 'Comparte este enlace con todos tus amigos',
            url: 'https://www.tu-enlace.com',
          });
        } else {
          // Si es en un entorno web (simulador o navegador), usaremos el comportamiento estándar del navegador
          navigator.share({
            title: 'Comparte y gana',
            text: 'Comparte este enlace con todos tus amigos',
            url: 'https://www.tu-enlace.com',
          });
        }
  
        // await Share.share({
        //   title: 'Comparte y gana',
        //   text: 'Comparte este enlace con todos tus amigos',
        //   url: mensaje,
        //   dialogTitle: 'Compartir enlace',
        // });

      }
    }
  }
</script>

<style scoped>

  /* STYLE FOR AVISO PAGO  */
  .responsive-banner {
    min-width: 230px;
    position: relative;
    height: auto;
    border-radius: 10px;
    overflow: hidden;
    background-image: linear-gradient(to bottom right, #5BC2D4, #84D9E0);
    background-repeat: no-repeat;
    box-shadow: 0 20px 27px 0 rgba(0,0,0,0.05)  !important;
  }

  .container-envelope {
    padding: 35px 15px;
    color: #fff;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
  }

  .col-xs-12 {
    text-align: center;
  }

  img {
    width: 100%;
    position: relative;
  }

  span:after,
  span:before {
    content: "";
    position: absolute;
    display: block;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.1);
    width: 50px;
    height: 50px;
  }

  .circle-a:before {
    width: 500px;
    height: 500px;
    top: -300px; left: 52%;
    -webkit-transform: translate(-50%,0);
    -ms-transform: translate(-50%,0);
    transform: translate(-50%,0);
  }

  .circle-a:after {
    top: 160px;
    right: 10%;
  }

  .circle-b:before {
    top: 60%;
    left: -25px;
  }

  .circle-b:after {
    width: 150px;
    height: 150px;
    bottom: -70px;
    right: -70px;
  }

  /* Demo Stuff */
  a.more-link {
    background-color: rgba(255, 255, 255, 0.35);
    display: inline-block;
    padding: 12px 18px;
    color: #fff;
    text-decoration: none;
    font: 500 15px 'Work Sans', Helvetica, sans-serif;
    line-height: 1.5;
    text-align: center;
    border: none !important;
    position: relative;
    border-radius: 30px;
    text-transform: uppercase;
    -webkit-transition: .1s all ease-in-out;
    -moz-transition: .1s all ease-in-out;
    -o-transition: .1s all ease-in-out;
    transition: .1s all ease-in-out;
  }
  a.more-link:hover {
    background-color: rgba(255, 255, 255, 0.50);
  }
  
  .link-container {
    text-align: center;
  }
  .link-container a.more-link {
    font-family: 'Source Sans Pro', Helvetica, sans-serif;
    background-color: #90b0bf;
    color: #fff;
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
    line-height: 1.5;
    text-decoration: none;
    text-transform: none;
    font-weight: 400;
    letter-spacing: 1px;
  }

</style>